import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ProductPodPropTypes, ProductPodDefaultProps } from './Helper';
import { dataModel } from './dataModel';
import { ProductPodDesktop } from './ProductPodDesktop';
import { ProductPodMobile } from './ProductPodMobile';

export const ProductPod = (props) => {
  const { channel } = useContext(ExperienceContext);
  if (channel === 'mobile') {
    /* eslint-disable react/jsx-props-no-spreading */
    return (<ProductPodMobile {...props} />);
  }
  /* eslint-disable react/jsx-props-no-spreading */
  return (<ProductPodDesktop {...props} />);
};

ProductPod.propTypes = ProductPodPropTypes;

ProductPod.defaultProps = ProductPodDefaultProps;

ProductPod.dataModel = dataModel;

ProductPod.displayName = 'ProductPod';
